import { useEffect, useRef, useState } from 'react';

/**
 * Chạy số từ giá trị cũ tới giá trị mới (đếm mượt).
 *
 * Chạy từ giá trị TRƯỚC ĐÓ chứ không phải từ 0: widget hũ tự cập nhật liên tục,
 * nếu mỗi nhịp đều đếm lại từ 0 thì con số nhấp nháy khó chịu.
 */
export function useCountUp(end: number, durationMs = 800): number {
  const [value, setValue] = useState(end);
  const previous = useRef(end);

  useEffect(() => {
    const from = previous.current;
    previous.current = end;
    if (from === end) return;

    let frame = 0;
    let startedAt: number | null = null;

    const step = (timestamp: number): void => {
      startedAt ??= timestamp;
      const progress = Math.min((timestamp - startedAt) / durationMs, 1);
      // Ease-out cubic — chậm dần về đích, dễ đọc hơn tuyến tính.
      const eased = 1 - (1 - progress) ** 3;

      setValue(Math.round(from + (end - from) * eased));
      if (progress < 1) frame = requestAnimationFrame(step);
    };

    frame = requestAnimationFrame(step);
    return () => {
      cancelAnimationFrame(frame);
    };
  }, [end, durationMs]);

  return value;
}
